module.exports = __webpack_public_path__ + "img/icon-sb-buy-set-illustration-343x129.92db2c7.svg";